import { Inject, Injectable, InjectionToken } from '@angular/core';

import { Socket } from 'phoenix';

import { HttpApiService } from '@recruitee/http';

import { WebsocketService } from '../websocket.service';

export interface ReferralsWebsocketServiceConfig {
  websocketUrl: string;
}

@Injectable({ providedIn: 'root' })
export class ReferralsWebsocketService extends WebsocketService {
  public static config: InjectionToken<ReferralsWebsocketServiceConfig> = new InjectionToken(
    'ReferrerWebsocketService config',
  );

  constructor(
    @Inject(ReferralsWebsocketService.config)
    private config: ReferralsWebsocketServiceConfig,
    private httpApiService: HttpApiService,
  ) {
    super();

    this.httpApiService.get('/socket_token').subscribe(({ token }) => this.connect(token));
  }

  public connect(token: string): Socket {
    return this.socketConnect(this.config.websocketUrl, {
      params: { socket_token: token },
    });
  }
}
